import React from 'react'
import convertUnit from 'lib/unit'
import {RoboyuColorTheme} from '../../../types'
import {RoboyuAssetProps} from './RoboyuAssetProps'

export default function RoboyuConfused({
  width = convertUnit(519),
  height = convertUnit(673),
  colorTheme = 'blue',
  ...props
}: RoboyuAssetProps) {
  return (
    <svg
      {...props}
      width={width}
      height={height}
      viewBox="0 0 2000 2000"
      fill="none">
      <g filter="url(#filter0_d_4220_34098)">
        <path
          d="M1553.52 370.924H1493.72V324.199H1370.37V370.924H1312.42V444.599H1398.4V410.174H1467.55V479.324H1390.92V579.424H1476.9V494.274H1553.52V370.924Z"
          fill="#74CDDB"
        />
        <path
          d="M1476.9 612.023H1390.92V672.698H1476.9V612.023Z"
          fill="#74CDDB"
        />
        <path
          d="M697.824 1355.83C720.574 1318.63 792.499 1357.8 798.749 1365.5C804.999 1373.2 703.874 1583.2 662.499 1612.18C621.124 1641.15 604.999 1507.5 697.824 1355.83Z"
          fill="white"
        />
        <path
          d="M662.5 1612.17C659.822 1614.19 656.687 1615.51 653.375 1616.02C637.55 1604.07 663.05 1457.22 742.125 1341.02C768.1 1345.2 795 1360.87 798.7 1365.45C805 1373.17 703.875 1583.2 662.5 1612.17Z"
          fill="#5D76A1"
        />
        <path
          d="M792.924 1373.5C794.249 1369.05 779.449 1354.38 750.249 1342.73C773.474 1348.38 795.424 1361.4 798.749 1365.5C804.449 1372.5 720.899 1547.7 674.774 1600.5C712.699 1549.03 756.274 1470.95 792.924 1373.5Z"
          fill="#BDE5EE"
        />
        <path
          d="M734.625 1423.07C748.975 1286.82 865.875 1237.35 1002.12 1251.72C1138.37 1266.1 1242.37 1338.82 1228.02 1475.07C1213.67 1611.32 1086.52 1757.7 950.275 1743.35C814.025 1729 720.25 1559.3 734.625 1423.07Z"
          fill="white"
        />
        <path
          d="M1205.4 1358.68C1180.67 1417.95 1105.55 1474.08 926.75 1456.7C818.75 1446.23 766.425 1414.9 743.65 1379.2C739.15 1393.51 736.126 1408.25 734.625 1423.18C720.25 1559.4 814.025 1729.08 950.275 1743.45C1086.52 1757.83 1213.62 1611.33 1228 1475C1232.82 1429.13 1224.2 1390.38 1205.4 1358.68Z"
          fill="#98B1DC"
        />
        <path
          d="M819.6 1447.22C828.475 1363.1 903.275 1341.07 991.7 1350.4C1080.12 1359.72 1148.7 1396.85 1139.82 1481C1130.95 1565.15 1052.07 1625.8 963.65 1616.47C875.225 1607.15 810.725 1531.37 819.6 1447.22Z"
          fill="#BDE5EE"
        />
        <path
          d="M820 1444.62C828.675 1362.4 903.4 1341.07 991.825 1350.4C1080.25 1359.72 1148.9 1396.17 1140.22 1478.37C1131.55 1560.57 1052.72 1619.67 964.425 1610.35C876.125 1601.02 811.225 1526.82 820 1444.62Z"
          fill={RoboyuColorTheme[colorTheme].face_body_outline}
        />
        <path
          d="M831.024 1447.12C839.074 1370.72 908.524 1350.87 990.749 1359.62C1072.97 1368.37 1136.75 1402.12 1128.7 1478.6C1120.65 1555.07 1047.5 1610 965.274 1601.2C883.049 1592.4 822.949 1523.55 831.024 1447.12Z"
          fill={RoboyuColorTheme[colorTheme].face_body_2}
        />
        <path
          d="M1127.25 1445.13C1115.9 1391.93 1059.75 1366.83 990.749 1359.55C908.549 1350.88 839.074 1370.73 831.024 1447.05C830.011 1456.59 830.061 1466.22 831.174 1475.75C849.949 1485.95 873.674 1494.88 903.674 1501.85C1013.87 1527.63 1090 1493.28 1127.25 1445.13Z"
          fill={RoboyuColorTheme[colorTheme].face_body_1}
        />
        <path
          d="M1074.72 1442.05L1058.05 1440.28L1059.75 1424.23L1026.77 1420.75L1025.07 1436.8L1007.27 1434.93L1005.85 1448.55L992.425 1447.13L990.95 1461.05L980.325 1459.93L970.5 1458.9L972 1444.65L957.45 1443.13L958.875 1429.58L939.375 1427.53L940.95 1412.65L907.975 1409.18L906.4 1424.05L891.425 1422.45L885.675 1476.85L904.425 1478.83L901.425 1507.2L934.85 1510.73L932.5 1532.88L955.625 1535.33L954.05 1550.33L987.025 1553.8L988.6 1538.8L1011.22 1541.18L1013.57 1519.03L1047.6 1522.6L1050.57 1494.5L1069 1496.43L1074.72 1442.05Z"
          fill={RoboyuColorTheme[colorTheme].heart_hair_2}
        />
        <path
          d="M1073.9 1441.95L1058.05 1440.28L1059.75 1424.23L1026.77 1420.75L1025.07 1436.8L1007.27 1434.93L1005.85 1448.55L992.424 1447.13L990.949 1461.05L980.324 1459.93L970.499 1458.9L971.999 1444.65L957.449 1443.13L958.874 1429.58L939.374 1427.53L940.949 1412.65L907.974 1409.18L906.399 1424.05L891.399 1422.45L885.649 1476.85L904.399 1478.83L903.274 1489.43C911.449 1492.18 920.324 1494.78 929.974 1497.18C1000.37 1514.8 1045.65 1481.85 1073.9 1441.95Z"
          fill={RoboyuColorTheme[colorTheme].heart_hair_1}
        />
        <path
          d="M947.5 1727.25C883.15 1719.97 836.325 1690.6 802.225 1652.25C840 1701.55 891.1 1737.02 950.225 1743.27C1027.72 1751.42 1102.05 1707.7 1154.55 1643.45C1108.05 1696.05 1040.97 1737.8 947.5 1727.25Z"
          fill="#BDE5EE"
        />
        <path
          d="M1416.27 956.574C1464.57 1210.35 1249.57 1251.57 984.25 1302.12C718.925 1352.67 503.775 1393.22 455.475 1139.42C407.175 885.624 583.1 638.974 848.425 588.474C1113.75 537.974 1367.97 702.774 1416.27 956.574Z"
          fill="white"
        />
        <path
          d="M984.25 1302.13C1249.57 1251.63 1464.58 1210.35 1416.28 956.576C1413.32 941.171 1409.56 925.933 1405 910.926C1333.47 1031.2 1140.97 1222.03 746.45 1250.68C626.725 1259.38 542.025 1247.5 482.5 1224.15C560.65 1382.5 753.45 1346.05 984.25 1302.13Z"
          fill="#98B1DC"
        />
        <path
          d="M1341.42 959.775C1382.82 1177.27 1200.4 1212.27 975.3 1255.12C750.2 1297.97 567.675 1332.5 526.275 1115C484.875 897.5 649.175 767.1 874.275 724.25C1099.37 681.4 1300 742.275 1341.42 959.775Z"
          fill="#BDE5EE"
        />
        <path
          d="M1340.85 956.648C1381.82 1171.95 1199.4 1206.97 974.299 1249.82C749.199 1292.67 566.649 1327.1 525.674 1111.8C484.699 896.498 649.174 767.098 874.274 724.298C1099.37 681.498 1299.85 741.323 1340.85 956.648Z"
          fill={RoboyuColorTheme[colorTheme].face_body_outline}
        />
        <path
          d="M1326.95 961.025C1366.3 1167.8 1190.25 1201.6 972.975 1242.95C755.7 1284.3 579.55 1317.5 540.2 1110.75C500.85 904 659.675 779.575 876.925 738.25C1094.17 696.925 1287.5 754.25 1326.95 961.025Z"
          fill={RoboyuColorTheme[colorTheme].face_body_2}
        />
        <path
          d="M1308.52 898.1C1244.72 742.825 1070.25 701.425 876.925 738.1C659.675 779.45 500.85 903.85 540.2 1110.6C543.043 1125.89 547.054 1140.93 552.2 1155.6C600 1196.13 678.025 1221.53 803.65 1212.73C1108.47 1191.38 1253.97 1023.65 1308.52 898.1Z"
          fill={RoboyuColorTheme[colorTheme].face_body_1}
        />
        <path
          d="M788.961 1003.93L642.665 1031.78C625.778 1035 614.695 1051.29 617.91 1068.18L619.486 1076.45C622.701 1093.34 638.997 1104.42 655.884 1101.21L802.18 1073.35C819.067 1070.14 830.15 1053.84 826.935 1036.96L825.359 1028.68C822.144 1011.79 805.848 1000.71 788.961 1003.93Z"
          fill={RoboyuColorTheme[colorTheme].eyes}
        />
        <path
          d="M1181.03 929.257L1034.74 957.112C1017.85 960.327 1006.77 976.623 1009.98 993.509L1011.56 1001.79C1014.77 1018.67 1031.07 1029.76 1047.96 1026.54L1194.25 998.685C1211.14 995.47 1222.22 979.174 1219.01 962.288L1217.43 954.012C1214.22 937.125 1197.92 926.042 1181.03 929.257Z"
          fill={RoboyuColorTheme[colorTheme].eyes}
        />
        <path
          d="M1234.17 1478.63C1265.32 1504.38 1314 1392.3 1316.87 1377.25C1319.75 1362.2 1167.02 1192.5 1122.72 1193.35C1078.42 1194.2 1107.05 1373.55 1234.17 1478.63Z"
          fill="white"
        />
        <path
          d="M1113.13 1237.65C1109.78 1221.65 1109.5 1208.95 1111.5 1198.93C1085.28 1230 1120 1384.28 1234.18 1478.63C1249.18 1491.13 1268.35 1471.35 1284.45 1445.95C1237.5 1419 1131.85 1327.18 1113.13 1237.65Z"
          fill="#98B1DC"
        />
        <path
          d="M1237.07 1468.23C1137.3 1385.73 1098.2 1257.53 1107.42 1205.73C1089.7 1248.23 1126.82 1389.88 1234.17 1478.58C1265.32 1504.33 1314 1392.25 1316.87 1377.2C1316.93 1376.85 1316.93 1376.48 1316.87 1376.13C1305.4 1407 1264.47 1490.88 1237.07 1468.23Z"
          fill="#BDE5EE"
        />
        <path
          d="M828.874 547.875C828.874 547.875 806.024 347.875 822.924 342.25C839.824 336.625 917.924 361 917.924 361C917.924 361 976.999 251.6 981.999 257.75C986.999 263.9 1008.47 449.725 1000.6 455C992.724 460.275 894.999 453.275 894.999 453.275C894.999 453.275 830.424 571.125 828.874 547.875Z"
          fill={RoboyuColorTheme[colorTheme].heart_hair_2}
        />
        <path
          d="M917.9 360.998C917.9 360.998 839.85 336.648 822.9 342.248C805.95 347.848 828.85 547.873 828.85 547.873C831.875 548.923 878.85 403.898 881.35 404.148C883.85 404.398 962.225 411.648 963.85 407.873C965.475 404.098 983.2 269.748 981.85 257.873C977 251.598 917.9 360.998 917.9 360.998Z"
          fill={RoboyuColorTheme[colorTheme].heart_hair_1}
        />
      </g>
      <defs>
        <filter
          id="filter0_d_4220_34098"
          x="407.494"
          y="221.5"
          width="1186.03"
          height="1566.93"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB">
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="20" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.3375 0 0 0 0 0.3375 0 0 0 0 0.3375 0 0 0 0.15 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_4220_34098"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_4220_34098"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  )
}
